module.exports = __webpack_public_path__ + "img/grat.c614490c.png";